// Da Vinci Global Event Bus
// Decouples components from direct references

const listeners = {};

export const DaVinciEvents = {
    // Event Types
    ON_BLOCK_ADD: 'block:add',
    ON_BLOCK_DELETE: 'block:delete',
    ON_BLOCK_UPDATE: 'block:update',
    ON_BLOCK_MOVE: 'block:move',

    ON_STATE_CHANGE: 'state:change',
    ON_SETTINGS_TOGGLE: 'settings:toggle',

    ON_SAVE: 'project:save',
    ON_SAVE_DRAFT: 'project:save_draft',
    ON_PUBLISH: 'project:publish',
    ON_EXIT: 'project:exit',

    // Methods
    on(event, callback) {
        if (!listeners[event]) listeners[event] = [];
        listeners[event].push(callback);
        return () => this.off(event, callback); // Return unbind function
    },

    off(event, callback) {
        if (!listeners[event]) return;
        listeners[event] = listeners[event].filter(cb => cb !== callback);
    },

    emit(event, payload) {
        if (!listeners[event]) return;
        listeners[event].forEach(cb => {
            try {
                cb(payload);
            } catch (err) {
                console.error(`[DaVinciEvents] Error in listener for ${event}:`, err);
            }
        });
    }
};
